import { tagTheme } from '@taglivros/tag-components'
import React from 'react'
import * as S from './styles'

const Button = ( { children, backgroundColor, border = 'none', color, href, onClick, className = 'button', target, hover = backgroundColor }: Button.Props ): React.ReactElement => {
  return (
    <S.Container
      $backgroundColor={ backgroundColor }
      $border={ border }
      $color={ color }
      $hover={ hover }
      className={ className }
      href={ href }
      onClick={ onClick }
      target={ target }
    >
      { children }
    </S.Container>
  )
}

namespace Button {
  export interface Props {
    children: React.ReactNode
    backgroundColor: keyof typeof tagTheme.cores
    border?: keyof typeof tagTheme.cores | 'none'
    color: keyof typeof tagTheme.cores
    hover?: keyof typeof tagTheme.cores
    href?: string
    onClick?( event: React.MouseEvent<HTMLAnchorElement> ): void
    className?: string
    target?: '_blank' | '_self'
  }
}

export default Button
